import { styled } from '@linaria/react';

export const Container = styled.div<{ width: number; height: number }>`
	position: relative;
	display: flex;
	width: ${({ width }) => width}px;
	height: ${({ height }) => height}px;
	align-items: center;
`;

export const Body = styled.div<{
	height: number;
	offset: number;
	color?: string;
	borderColor?: string;
}>`
	width: calc(100% - ${({ offset }) => offset}px * 2);
	height: ${({ height }) => height}px;
	border: 1px solid;
	border-color: ${({ borderColor }) => borderColor || 'transparent'};
	border-radius: var(--radius-xl);
	margin-left: ${({ offset }) => offset}px;
	background-color: ${({ color }) => color || 'var(--color-black-solid)'};
	transition: background-color 0.2s;
`;

export const Thumb = styled.div<{
	checked: boolean;
	size: number;
	offset: number;
}>`
	position: absolute;
	left: ${({ checked, size, offset }) =>
		checked
			? 'calc(100% - ' + size + 'px' + ' - ' + offset + 'px)'
			: offset + 'px'};
	display: flex;
	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
	padding: 3px;
	border-radius: 100%;
	background-color: var(--color-white-solid);
	transition: left 200ms;

	img {
		margin: auto;
		opacity: ${({ checked }) => (checked ? 1 : 0)};
		transition: opacity 200ms;
	}
`;
